import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { RefreshCcw } from 'lucide-react';

interface AppUpdatePopupProps {
  isOpen: boolean;
  onUpdate: () => void;
  version?: string;
}

export const AppUpdatePopup: React.FC<AppUpdatePopupProps> = ({
  isOpen,
  onUpdate,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
          className="fixed top-3 left-1/2 z-[9999] w-[calc(100%-1rem)] max-w-md -translate-x-1/2"
        >
          <div className="flex items-center justify-between gap-3 rounded-lg border border-blue-200 bg-white/95 px-3 py-2 shadow-md backdrop-blur dark:border-blue-900/40 dark:bg-gray-900/95">
            <div className="min-w-0">
              <p className="text-xs font-semibold text-gray-900 dark:text-white">
                New update available
              </p>
              <p className="truncate text-[11px] text-gray-500 dark:text-gray-400">
                Refresh to load the latest files.
              </p>
            </div>

            <button
              onClick={onUpdate}
              className="shrink-0 inline-flex items-center gap-1.5 rounded-md bg-[#3967fe] px-2.5 py-1.5 text-[11px] font-semibold text-white transition hover:bg-[#2f5af0]"
            >
              <RefreshCcw className="h-3.5 w-3.5" />
              Refresh
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
